import apiClient from "../config/apiClient";


export const fetchVitals = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=patient/${id}/vitals?labour_id=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
